/** @format */

import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import {
  MembershipFailed,
  MembershipPayment,
  MembershipSuccess,
} from '../Components/Membership';
import { checkLogin } from '../Shared/hooks/authenticate';
import ProtectedRoutes from '../Routes/ProtectedRoutes';
import RestrictedRoutes from '../Routes/RestrictedRoutes';

const MembershipRoutes = () => {
  const location = useLocation();

  if (!checkLogin()) {
    const returnUrl = encodeURIComponent(
      `${location.pathname}${location.search}`,
    );
    return <Navigate to={`/login?redirect=${returnUrl}`} replace />;
  }

  return (
    <Routes>
      <Route path='/panel/membership/payment' element={<MembershipPayment />} />
      <Route path='/panel/membership/success' element={<MembershipSuccess />} />
      <Route path='/panel/membership/failed' element={<MembershipFailed />} />
      <Route path='*' element={<Navigate to='/panel' replace />} />
    </Routes>
  );
};

const App = () => {
  const { pathname } = useLocation();
  const loggedIn = checkLogin();

  if (pathname.startsWith('/panel/membership')) {
    return <MembershipRoutes />;
  }

  return loggedIn ? <ProtectedRoutes /> : <RestrictedRoutes />;
};

export default App;
